import type {
	CardEntityDocumentId,
	WhiteboardDocumentId,
} from "@src/components/collaboration/document-id";
import config from "@src/config";
import posthog from "posthog-js";

const POSTHOG_DEBUG_LOGGING_ENVIRONMENTS = new Set(["proto-gcp"]);

function isPostHogDebugLoggingEnabled(): boolean {
	const environmentName = config.sentry.environment;
	if (!environmentName) {
		return true;
	}
	return POSTHOG_DEBUG_LOGGING_ENVIRONMENTS.has(environmentName);
}

function getClientType(): "desktop" | "webapp" {
	return typeof window !== "undefined" &&
		Boolean(window.electronAPI?.isElectron)
		? "desktop"
		: "webapp";
}

export function capture(event: string, properties?: Record<string, unknown>) {
	const enrichedProperties = {
		client: getClientType(),
		...properties,
	};
	if (isPostHogDebugLoggingEnabled()) {
		// biome-ignore lint/suspicious/noConsole: intentional debug logging
		console.log("[PostHog]", event, enrichedProperties);
	}
	posthog.capture(event, enrichedProperties);
}

export function normalizeBoardId(boardId: WhiteboardDocumentId): string {
	return boardId.toString();
}

export function normalizeCardId(cardId: CardEntityDocumentId): string {
	return cardId.toString();
}

export function captureWithBoardId(
	event: string,
	boardId: WhiteboardDocumentId,
	properties?: Record<string, unknown>,
) {
	capture(event, {
		board_id: normalizeBoardId(boardId),
		...properties,
	});
}
